import React, { Fragment } from 'react';
import styles from './PhotosDragAndDrop.module.css';
import Header from '../../components/Header/Header';
import Container from '../../components/Container/Container';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import Sidebar from '../../components/Sidebar/Sidebar';
import Backdrop from '../../components/Backdrop/Backdrop';
import axios from 'axios';
import clsx from 'clsx';
import initState from './initState';
import { confirmAlert } from 'react-confirm-alert';


import apiConfig, { domain } from '../../lib/env';

const filterOut = (list, id) => {
  return list.filter(element => element.id !== id);
};

// moving photos between s3 dirs are made by s3 asynchronously, so sometimes after moving photo to
// trash foto is is 404 for img src and we need to wait a THIS time to load all images by browser propertly
const LOAD_DELAY = 1000;

class PhotosDragAndDropApp extends React.PureComponent {
  autoLoadPhotosDelay = 5000;

  constructor(props) {
    super(props);
    this.state = {
      students: [],
      classrooms: [],
      photos: [],
      selectedPhotos: [],
      draggedPhotos: [],
      trashedPhotos: [],
      autoLoadPhotos: {
        active: false, 
        timer: null,
        paused: false,
      },
      emailPhotos: [],
      isLoadingClassrooms: false,
      isLoadingStudents: false,
      isLoadingPhotos: false,
      isStudentBoxMoving: false,
      isLoadingTrashSidebar: false,
      studentFilter: '',
      classroomFilter: '',
      isLoadingAssignment: true,
      boxOfAssignment: '',
      hidePhotoIds: [],
      ...initState,
    };
  }

  changeUsersFilter = value => {
    const currentStudentFilter = this.state.studentFilter;

    if (value !== currentStudentFilter) {
      this.setState({ studentFilter: value });
    }
  };
  changeClassroomFilter = value => {
    const currentClassroomFilter = this.state.classroomFilter;

    if (value !== currentClassroomFilter) {
      this.setState({ classroomFilter: value });
    }
  };

  componentWillMount() {
    this.getStudents();
    this.getClassrooms();
    this.getPhotos();
    this.getTrashedPhotos();
  }

  handleReload = () => {
    this.setState({
      classrooms: [],
      students: [],
      photos: [],
    });
    this.getStudents();
    this.getClassrooms();
    this.getPhotos();
  };

  getClassrooms = () => {
    this.setState({
      isLoadingClassrooms: true,
    });

    axios({
      url: apiConfig.baseUrl + '/classrooms',
      method: 'GET',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
    })
      .then(items => {
        this.setState({
          classrooms: items.data.data,
          isLoadingClassrooms: false,
        });
      })
      .catch(() => {
        alert('Sorry, something went wrong. Please try again.');
      });
  };

  getStudents = (event, showLoading = true) => {
    if (showLoading === true) {
      this.setState({
        isLoadingStudents: true,
      });
    }

    axios({
      url: apiConfig.baseUrl + '/users',
      method: 'GET',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
    })
      .then(users => {
        const loadedStudents = users.data.data;
        this.setState({
          students: loadedStudents,
          isLoadingStudents: false,
        });
      })
      .catch(() => {
        alert('Sorry something went wrong. Please, try again.');
      });
  };

  getPhotos = () => {
    this.setState({
      isLoadingPhotos: true,
      photos: [],
    });

    axios({
      url: apiConfig.baseUrl + '/photos',
      method: 'GET',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
    })
      .then(photos => {
        this.setState({
          photos: photos.data.data,
          isLoadingPhotos: false,
        });
      })
      .catch(() => {
        alert('Sorry, something went wrong. Please, try again');
      });
  };

  getTrashedPhotos = () => {
    this.setState({
      isLoadingTrashSidebar: true,
    })
    axios({
      url: apiConfig.baseUrlv2 + '/trash/photos',
      method: 'GET',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
    })
      .then(photos => {
        this.setState({
          trashedPhotos: photos.data.data,
          isLoadingTrashSidebar: false,
        });
      })
      .catch((e) => {
        console.error(e);
        this.setState({ isLoadingTrashSidebar: false });
      });
  }

  toggleAutoLoadPhotos = (event, forceStart = false) => {
    if(event && event.stopPropagation) {
      event.stopPropagation();
    }

    const { autoLoadPhotos } = this.state;
    clearInterval(autoLoadPhotos.timer);

    if (forceStart || !autoLoadPhotos.active) {
      const timer = setInterval(() => this.getPhotos(), this.autoLoadPhotosDelay);

      this.setState({
        autoLoadPhotos: {
          ...autoLoadPhotos,
          active: true,
          paused: false,
          timer,
        },
      });
    } else {
      this.setState({
        autoLoadPhotos: {
          ...autoLoadPhotos,
          active: false,
          paused: false,
        },
      });
    }
  };

  pauseAutoLoadPhoto = () => {
    const { autoLoadPhotos } = this.state;

    if(!autoLoadPhotos.active) {
      return;
    }
    
    clearInterval(autoLoadPhotos.timer);

    const timer = setTimeout(() => {
      this.toggleAutoLoadPhotos(null, true);
    }, this.autoLoadPhotosDelay)

    this.setState({
      autoLoadPhotos: {
        ...autoLoadPhotos,
        timer,
        paused: true,
      },
    });
  };

  filteredClassrooms = () => {
    const input = this.state.classroomFilter;
    return this.state.classrooms
      .filter(classroom => {
        return (
          this.checkMatching(classroom.attributes.teacher_last_name, input) ||
          this.checkMatching(classroom.attributes.teacher_first_name, input)
        );
      })
      .sort((a, b) => {
        if (a.attributes.event_processed_at === b.attributes.event_processed_at) {
          return 0;
        } else {
          if (a.attributes.event_processed_at) {
            return 1;
          } else {
            return -1;
          }
        }
      });
  };

  sortStudents = students => {
    return students.sort((a, b) => {
      if (a.attributes.event_processed_at === b.attributes.event_processed_at) {
        return 0;
      } else {
        if (a.attributes.event_processed_at) {
          return 1;
        } else {
          return -1;
        }
      }
    });
  };

  filteredStudents = () => {
    const input = this.state.studentFilter;

    return this.sortStudents(
      this.state.students.filter(user => {
        return (
          this.checkMatching(user.attributes.last_name, input) ||
          this.checkMatching(user.attributes.first_name, input) ||
          this.checkMatching(user.attributes.email, input)
        );
      }),
    );
  };

  filteredPhotos = () => {
    const input = [...this.state.photos];
    return input;
  };

  checkMatching = (name, input) => {
    if (input) {
      return (name || '').toLowerCase().includes(input.toLowerCase());
    } else {
      return true;
    }
  };

  emptyTrashConfirmation = () => {
    this.setState({
      isLoadingTrashSidebar: true,
    });

    confirmAlert({
      title: 'Confirm to submit',
      message: 'Trash photos will be DELETED PERMANENTLY. Are you sure?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.emptyTrash(),
        },
        {
          label: 'No',
          onClick: () => {
            this.setState({
              isLoadingTrashSidebar: false,
            });
          },
        },
      ],
    });
  };

  finishWorkingOnThisStudent = objectId => {
    const finishedStudent = this.state.students.find(student => student.id === objectId);

    if (finishedStudent.attributes.event_processed_at === null) {
      if (
        finishedStudent.attributes.showUndoLink ||
        finishedStudent.attributes.assigned_photos_count > 0
      ) {
        this.finishWorkingOnStudentWithoutPhotos(finishedStudent, objectId);
      } else {
        const finishConfirmed = window.confirm(
          'Achtung! Dem/der Schüler/in, die du abschliessen möchtest, wurden keine Fotos zugewiesen.',
        );

        if (finishConfirmed) {
          this.finishWorkingOnStudentWithoutPhotos(finishedStudent, objectId);
        }
      }
    } else {
      const url = `${apiConfig.baseUrl}/users/${objectId}/processed`;

      axios({
        url: url,
        method: 'PATCH',
        auth: {
          username: apiConfig.auth.user,
          password: apiConfig.auth.password,
        },
        data: {
          data: {
            attributes: {
              event_processed_at: null,
            },
          },
        }
      })
        .then(response => {
          const filteredStudents = [
            ...this.state.students.filter(el => el.id !== finishedStudent.id),
          ];
          const finishedStudentState = {
            ...this.state.students.find(el => el.id === finishedStudent.id),
          };

          const newFinishedStudentState = {
            ...finishedStudentState,
            attributes: {
              ...finishedStudentState.attributes,
              event_processed_at: null,
            },
          };
          const newUpdatedStudents = [...filteredStudents, { ...newFinishedStudentState }];

          this.setState({
            students: newUpdatedStudents,
          });
        })
        .catch(() => {
          alert('Sorry, something went wrong. Please, try again');
        });
    }
  };

  finishWorkingOnStudentWithoutPhotos = (finishedStudent, objectId) => {
    const now = new Date();
    const url = `${apiConfig.baseUrl}/users/${objectId}/processed`;

    axios({
      url: url,
      method: 'PATCH',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        data: {
          attributes: {
            event_processed_at: now,
          },
        },
      }
    })
      .then(response => {
        const filteredStudents = [
          ...this.state.students.filter(el => el.id !== finishedStudent.id),
        ];
        const finishedStudentState = {
          ...this.state.students.find(el => el.id === finishedStudent.id),
        };

        const newFinishedStudentState = {
          ...finishedStudentState,
          attributes: {
            ...finishedStudentState.attributes,
            event_processed_at: now,
          },
        };
        const newUpdatedStudents = [...filteredStudents, { ...newFinishedStudentState }];

        this.setState({
          students: newUpdatedStudents,
        });
      })
      .catch(() => {
        alert('Sorry, something went wrong. Please, try again');
      });
  };

  finishWorkingOnThisClassroom = objectId => {
    const finishedClassroom = this.state.classrooms.find(classroom => classroom.id === objectId);
    const finishedClassroomIndex = this.state.classrooms.indexOf(finishedClassroom);
    const now = new Date();

    if (finishedClassroom.attributes.event_processed_at === null) {
      axios({
        url: apiConfig.baseUrl + '/classrooms/' + objectId,
        method: 'PATCH',
        auth: {
          username: apiConfig.auth.user,
          password: apiConfig.auth.password,
        },
        data: {
          data: {
            attributes: {
              event_processed_at: now,
            },
          },
        }
      })
        .then(response => {
          const filteredClassrooms = [
            ...this.state.classrooms.filter(el => el.id !== finishedClassroom.id),
          ];
          const finishedClassroomState = {
            ...this.state.classrooms.find(el => el.id === finishedClassroom.id),
          };

          const newFinishedClassroomState = {
            ...finishedClassroomState,
            attributes: {
              ...finishedClassroomState.attributes,
              event_processed_at: now,
            },
          };
          const newUpdatedClassrooms = [...filteredClassrooms, { ...newFinishedClassroomState }];

          this.setState({
            classrooms: newUpdatedClassrooms,
          });
        })
        .catch(() => {
          alert('Sorry, something went wrong. Please, try again');
        });
    } else {
      axios({
        url: apiConfig.baseUrl + '/classrooms/' + objectId,
        method: 'PATCH',
        auth: {
          username: apiConfig.auth.user,
          password: apiConfig.auth.password,
        },
        data: {
          data: {
            attributes: {
              event_processed_at: null,
            },
          },
        }
      })
        .then(response => {
          const filteredClassrooms = [
            ...this.state.classrooms.filter(el => el.id !== finishedClassroom.id),
          ];
          const finishedClassroomState = {
            ...this.state.classrooms.find(el => el.id === finishedClassroom.id),
          };

          const newFinishedClassroomState = {
            ...finishedClassroomState,
            attributes: {
              ...finishedClassroomState.attributes,
              event_processed_at: null,
            },
          };
          const newUpdatedClassrooms = [...filteredClassrooms, { ...newFinishedClassroomState }];

          this.setState({
            classrooms: newUpdatedClassrooms,
          });
        })
        .catch(() => {
          alert('Sorry, something went wrong. Please, try again');
        });
    }
  };

  assignPhotoToStudent = (photoId, studentId) => {
    const url = apiConfig.baseUrl + '/users/' + studentId + '/relationships/photos';

    const draggedPhotos = [photoId, ...this.state.draggedPhotos];

    this.setState({
      boxOfAssignment: studentId,
      isLoadingAssignment: true,
      hidePhotoIds: draggedPhotos,
    });

    axios({
      url: url,
      method: 'POST',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        data: draggedPhotos.map(el => ({ type: 'photos', id: el })),
      }
    })
      .then(result => {
        const currentPhotos = [...this.state.photos];
        const currentStudents = [...this.state.students];

        const filteredPhotos = currentPhotos.filter(el => !draggedPhotos.includes(el.id));

        const undoStudents = this.manageUndoButton(currentStudents, studentId);

        this.setState({
          photos: filteredPhotos,
          students: undoStudents,
          selectedPhotos: this.state.selectedPhotos.filter(el => !draggedPhotos.includes(el)),
        });
      })
      .catch(response => {
        if (response.status !== 204) {
          alert('Sorry, something went wrong. Please try again.');
        }
      })
      .then(() => {
        this.setState({
          isLoadingAssignment: false,
          hidePhotoIds: [],
        });
      });
  };

  assignPhotoToClassroom = (photoId, classroomId) => {
    const url = apiConfig.baseUrl + '/classrooms/' + classroomId + '/relationships/photos';

    const draggedPhotos = [photoId, ...this.state.draggedPhotos];

    this.setState({
      boxOfAssignment: classroomId,
      isLoadingAssignment: true,
      hidePhotoIds: draggedPhotos,
    });

    axios({
      url: url,
      method: 'POST',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        data: draggedPhotos.map(el => ({ type: 'photos', id: el })),
      }
    })
      .then(result => {
        const currentPhotos = [...this.state.photos];
        const currentClassrooms = [...this.state.classrooms];

        const filteredPhotos = currentPhotos.filter(el => !draggedPhotos.includes(el.id));
        const undoClassrooms = this.manageUndoButton(currentClassrooms, classroomId);

        this.setState({
          photos: filteredPhotos,
          classrooms: undoClassrooms,
          selectedPhotos: this.state.selectedPhotos.filter(el => !draggedPhotos.includes(el)),
        });
      })
      .catch(response => {
        if (response.status !== 204) {
          alert('Sorry, something went wrong. Please try again.');
        }
      })
      .then(() => {
        this.setState({
          isLoadingAssignment: false,
          hidePhotoIds: [],
        });
      });
  };

  assignStudentToClassroom = (studentId, classroomId) => {
    const item = this.state.students.find(el => el.id === studentId);

    if (item.attributes.showUndoLink || item.attributes.assigned_photos_count > 0) {
      this.assignStudentWithoutPhotos(studentId, classroomId);
    } else {
      const assignmentConfirmed = window.confirm(
        'Achtung! Dem/der Schüler/in, die du abschliessen möchtest, wurden keine Fotos zugewiesen.',
      );

      if (assignmentConfirmed) {
        this.assignStudentWithoutPhotos(studentId, classroomId);
      }
    }
  };

  movePhotosToTrash = (photoId) => {
    const {
      photos,
      trashedPhotos,
      draggedPhotos: draggedPhotosIds
    } = this.state;

    const draggedPhotosIdsWithCurrentPhotoId = [photoId, ...draggedPhotosIds];

    this.setState({
      hidePhotoIds: draggedPhotosIdsWithCurrentPhotoId,
      isLoadingTrashSidebar: true,
    })
    this.toggleSidebar("trash", true);

    axios({
      url: apiConfig.baseUrlv2 + '/photos/move_to_trash',
      method: 'POST',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        ids: draggedPhotosIdsWithCurrentPhotoId
      }
    }).then(() => {
      setTimeout(() => {
        this.setState({
          trashedPhotos: [...trashedPhotos, ...photos.filter(photo => draggedPhotosIdsWithCurrentPhotoId.includes(photo.id))],
          photos: photos.filter(photo => !draggedPhotosIdsWithCurrentPhotoId.includes(photo.id)),
          isLoadingTrashSidebar: false,
          selectedPhotos: [],
          draggedPhotos: [],
          hidePhotoIds: []
        })
      }, LOAD_DELAY);
    }).catch((e) => {
      console.error(e);
      this.setState({ isLoadingTrashSidebar: false });
    });
  }

  assingPhotosToEmail = (photoId) => {
    const {
      photos,
      emailPhotos,
      hidePhotoIds,
      draggedPhotos: draggedPhotosIds
    } = this.state;

    const draggedPhotosIdsWithCurrentPhotoId = [photoId, ...draggedPhotosIds];
    const draggedPhotosWithCurrentPhoto = photos.filter(photo => draggedPhotosIdsWithCurrentPhotoId.includes(photo.id));    

    this.setState({
      emailPhotos: [...emailPhotos, ...draggedPhotosWithCurrentPhoto],
      hidePhotoIds: [...hidePhotoIds, ...draggedPhotosIdsWithCurrentPhotoId],
      selectedPhotos: [],
      draggedPhotos: []
    })

    this.toggleSidebar("customEmail", true);
  }

  restorePhotoFromTrash = (photoId) => {
    const {
      photos,
      trashedPhotos,
    } = this.state;

    this.setState(({ isLoadingTrashSidebar: true }));

    const restoredPhoto = trashedPhotos.find(photo => photo.id === photoId);

    axios({
      url: apiConfig.baseUrlv2 + '/photos/restore_from_trash',
      method: 'POST',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        ids: [photoId]
      }
    }).then(() => {
      setTimeout(() => {
        this.setState({
          photos: [...photos, restoredPhoto],
          trashedPhotos: trashedPhotos.filter(photo => photo.id !== photoId),
          isLoadingTrashSidebar: false
        });
      }, LOAD_DELAY);
    }).catch((e) => {
      console.error(e);
      this.setState(({ isLoadingTrashSidebar: false }));
    })
  }

  restoreAllPhotosFromTrash = () => {
    const {
      photos,
      trashedPhotos,
      hidePhotoIds,
    } = this.state;

    this.setState(({ isLoadingTrashSidebar: true }));

    axios({
      url: apiConfig.baseUrlv2 + '/photos/restore_from_trash',
      method: 'POST',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        ids: trashedPhotos.map(photo => photo.id)
      }
    }).then(() => {
      setTimeout(() => {
        this.setState({
          photos: [...photos, ...trashedPhotos],
          trashedPhotos: [],
          hidePhotoIds: hidePhotoIds.filter(id => !trashedPhotos.map(photo => photo.id).includes(id)),
          isLoadingTrashSidebar: false
        });
        this.toggleSidebar("trash", false);
      }, LOAD_DELAY);
    }).catch((e) => {
      console.error(e);
      this.setState(({ isLoadingTrashSidebar: false }));
    });
  }

  emptyTrash = () => {
    const {
      trashedPhotos,
    } = this.state;

    axios({
      url: apiConfig.baseUrlv2 + '/trash/photos',
      method: 'DELETE',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        ids: trashedPhotos.map(photo => photo.id)
      }
    }).then(() => {
      this.setState({
        trashedPhotos: [],
        isLoadingTrashSidebar: false
      });
    }).catch((e) => {
      console.error(e);
      this.setState(({ isLoadingTrashSidebar: false }));
    });
  }
  
  deletePhotoFromEmailPhotos = deletedPhotoId  => {
    this.setState({
      emailPhotos: this.state.emailPhotos.filter(photo => !(photo.id === deletedPhotoId)),
      hidePhotoIds: this.state.hidePhotoIds.filter(photoId => !(photoId === deletedPhotoId)),
    })
  }

  assignStudentWithoutPhotos = (studentId, classroomId) => {
    const url = apiConfig.baseUrl + '/classrooms/' + classroomId + '/relationships/students';
    const filteredStudents = filterOut(this.state.students, studentId);

    this.setState({
      students: filteredStudents,
      boxOfAssignment: classroomId,
      isLoadingAssignment: true,
    });

    axios({
      url: url,
      method: 'POST',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        data: [{ type: 'students', id: studentId }],
      }
    })
      .catch(response => {
        if (response.status !== 204) {
          alert('Sorry, something went wrong. Please try again.');
          this.setState({
            students: [],
          });
          this.getStudents();
        }
      })
      .then(() => {
        this.setState({
          isLoadingAssignment: false,
        });
      });
  };

  manageUndoButton = (list, id, showUndoLink = true) => {
    const item = list.find(el => el.id === id);
    const index = list.indexOf(item);

    item.attributes.showUndoLink = showUndoLink;
    item.attributes.assigned_photos_count =
      showUndoLink === false ? 0 : item.attributes.assigned_photos_count;
    list[index] = item;
    return list;
  };

  undoStudentUpdate = studentId => {
    const url = apiConfig.baseUrl + '/users/' + studentId + '/relationships/photos/destroy_all';

    this.setState({
      boxOfAssignment: studentId,
      isLoadingAssignment: true,
    });

    axios({
      url: url,
      method: 'DELETE',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      }
    })
      .then(response => {
        this.manageUndoButton(this.state.students, studentId, false);
        this.getPhotos();
      })
      .catch(response => {
        if (response.status !== 204) {
          alert('Sorry, something went wrong. Please try again.');
        }
      })
      .then(() => {
        this.setState({
          isLoadingAssignment: false,
        });
      });
  };

  undoClassroomUpdate = classroomId => {
    const urlPhotos = apiConfig.baseUrl + '/classrooms/' + classroomId + '/relationships/photos';

    this.setState({
      boxOfAssignment: classroomId,
      isLoadingAssignment: true,
    });

    axios({
      url: urlPhotos,
      method: 'DELETE',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        data: [{ id: classroomId }],
      }
    })
      .then(response => {
        this.manageUndoButton(this.state.classrooms, classroomId, false);
        this.getPhotos();
      })
      .catch(response => {
        if (response.status !== 204) {
          alert('Sorry, something went wrong. Please try again.');
        }
      })
      .then(() => {
        this.setState({
          isLoadingAssignment: false,
        });
      });
  };

  getPhotosAssignedToStudent = studentId => {
    const url = apiConfig.baseUrl + '/users/' + studentId + '/relationships/photos';

    axios({
      url: url,
      method: 'GET',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
    })
      .then(result => {})
      .catch(response => {
        if (response.status !== 204) {
          alert('Sorry, something went wrong. Please try again.');
        }
      });
  };

  id2List = {
    droppableclassrooms: 'classrooms',
    droppablestudents: 'students',
    droppablephotos: 'photos',
  };

  getList = id => {
    const droppableId = id.split('-')[0];
    return this.state[this.id2List[droppableId]];
  };

  onDragStart = start => {
    const [itemType, itemId] = start.draggableId.split(/-(.*)$/);
    
    if (itemType === 'student') {
      this.setState({
        isStudentBoxMoving: true,
      });
    } else if (itemType === 'photo') {
      this.pauseAutoLoadPhoto();
      if(this.state.selectedPhotos.includes(itemId)) {
        this.setState({
          draggedPhotos: [...this.state.selectedPhotos.filter(el => el !== itemId)],
        });
      }
    }
  };

  onDragEnd = result => {
    this.processDragEnd(result);

    this.setState({
      draggedPhotos: [],
    });
  };

  processDragEnd = result => {
    const { source, destination } = result;
    const [srcType, srcId] = source.droppableId.split(/-(.*)$/);

    if (srcType === 'droppablestudents') {
      this.setState({ isStudentBoxMoving: false });
    }

    if (!destination) {
      return;
    }

    const [destType, destId] = destination.droppableId.split(/-(.*)$/);

    if (srcType === destType) {
      return;
    }

    if (srcType === 'droppablephotos' && destType === 'droppablestudents') {
      this.assignPhotoToStudent(srcId, destId);
    } else if (srcType === 'droppablephotos' && destType === 'droppableclassrooms') {
      this.assignPhotoToClassroom(srcId, destId);
    } else if (srcType === 'droppablestudents' && destType === 'droppableclassrooms') {
      this.assignStudentToClassroom(srcId, destId);
    } else if (srcType === 'droppablephotos' && destType === 'droppableemail') {
      this.assingPhotosToEmail(srcId);
    } else if (srcType === 'droppablephotos' && destType === 'droppabletrash') {
      this.movePhotosToTrash(srcId);
    }
  };

  toggleSidebar = (type, bool) => {
    const newState = {
      customEmail:{
        ...initState.customEmail,
        show: false,
      },
      trash: {
        ...initState.trash,
      },
      student: {
        ...initState.student,
        show: false,
      },
      teacher: {
        ...initState.teacher,
        show: false,
      },
      [type]: {
        ...this.state[type],
        show: !this.state[type].show || bool,
      },
    };

    this.setState({ student: newState.student });
    this.setState({ teacher: newState.teacher });
    this.setState({ customEmail: newState.customEmail });
    this.setState({ trash: newState.trash });
    this.setState({ [type]: newState[type] });
    this.setState({ conventionEmail: initState.conventionEmail });
    return newState;
  };

  globalToggle = () => {
    const {
      student: { show: studentShow },
      teacher: { show: teacherShow },
      customEmail: { show: customEmailShow },
    } = this.state;

    if (studentShow) this.toggleSidebar('student', false);
    if (teacherShow) this.toggleSidebar('teacher', false);
    if (customEmailShow) this.toggleSidebar('customEmail', false);
  };

  sidebarShowHandler = (type, id) => {
    let propertiesState;
    if (type === 'student') {
      propertiesState = this.getSidebarStudentData(id);
    } else if (type === 'teacher') {
      propertiesState = this.getSidebarTeacherData(id);
    } else if (type == 'customEmail') {
      propertiesState = this.getSidebarCustomEmailData();
    } else if (type == 'trash') {
      propertiesState = this.getSidebarTrashData();
    } else {
      return;
    }

    const sidebarState = this.toggleSidebar(type, true);

    const newState = { ...sidebarState, ...propertiesState };
    this.setState({ sidebar: newState });
  };

  clickCustomMailIcon = () => {
    const {
      selectedPhotos: selectedPhotosIds,
      photos,
      hidePhotoIds,
      emailPhotos
    } = this.state;

    const selectedPhotos = photos.filter(photo => selectedPhotosIds.includes(photo.id));

    if (selectedPhotos.length !== 0) {
      this.setState({
        emailPhotos: [...emailPhotos, ...selectedPhotos],
        hidePhotoIds: [...hidePhotoIds, ...selectedPhotosIds],
        selectedPhotos: [],
      })
    }

    this.sidebarShowHandler("customEmail")
  }

  clickTrashIcon = () => {
    const {
      selectedPhotos: selectedPhotosIds,
      photos,
      trashedPhotos,
    } = this.state;

    const selectedPhotos = photos.filter(photo => selectedPhotosIds.includes(photo.id));

    this.sidebarShowHandler('trash');

    if (selectedPhotos.length !== 0) {
      this.setState({
        isLoadingTrashSidebar: true,
        hidePhotoIds: [...selectedPhotosIds],
      })

      axios({
        url: apiConfig.baseUrlv2 + '/photos/move_to_trash',
        method: 'POST',
        auth: {
          username: apiConfig.auth.user,
          password: apiConfig.auth.password,
        },
        data: {
          ids: selectedPhotos.map(photo => photo.id),
        }
      }).then(() => {
        setTimeout(() => {
          this.setState({
            trashedPhotos: [...trashedPhotos, ...selectedPhotos],
            photos: photos.filter(photo => !selectedPhotosIds.includes(photo.id)),
            selectedPhotos: [],
            isLoadingTrashSidebar: false
          })
        }, LOAD_DELAY)
      }).catch(e => {
        console.error(e);
        this.setState({ isLoadingTrashSidebar: false });
      });
    }
  }

  getSidebarStudentData = id => {
    const studentData = [...this.state.students].find(el => el.id === id);
    const { first_name, last_name, email } = studentData.attributes;

    return {
      properties: {
        ...this.state.sidebar.properties,
        first_name,
        last_name,
        email,
        id,
      },
    };
  };

  getSidebarTeacherData = id => {
    const teacherData = [...this.state.classrooms].find(el => el.id === id);
    const {
      teacher_first_name,
      teacher_last_name,
      name,
      teacher_email,
      teacher_id,
    } = teacherData.attributes;

    return {
      properties: {
        ...this.state.sidebar.properties,
        first_name: teacher_first_name,
        last_name: teacher_last_name,
        className: name,
        email: teacher_email,
        teacher_id: teacher_id,
        id,
      },
    };
  };

  getSidebarCustomEmailData = () => {
    return {
      properties: {
        ...this.state.sidebar.properties,
        first_name: "Custom Email",
        id: "customEmail",
      }
    }
  }

  getSidebarTrashData = () => {
    return {
      properties: {
        last_name: "",
        first_name: "Trash",
        id: "trash",
      }
    }
  }

  resendConventionEmail = id => {
    const url = `${apiConfig.baseUrl}/users/${id}/send_convention_email`;

    this.setState({
      conventionEmail: {
        ...this.state.conventionEmail,
        sending: true,
      },
    });

    axios({
      url: url,
      method: 'POST',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {}
    })
      .then(res => {
        this.setState({
          conventionEmail: {
            sending: false,
            sent: true,
            error: false,
          },
        });
      })
      .catch(e => {
        if (e.status !== 204) {
          alert('Sorry, something went wrong. Please try again.');
          this.setState({
            conventionEmail: {
              sending: false,
              sent: false,
              error: true,
            },
          });
        }
      });
  };

  updateStudentEmail = (id, email) => {
    this.setState({
      studentEmail: {
        updating: true,
        updated: false,
        error: false,
        errorMessages: [],
      },
    });

    axios({
      url: apiConfig.baseUrl + '/users/' + id,
      method: 'PATCH',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        data: {
          attributes: {
            email: email,
          },
        },
      }
    })
      .then(res => {
        const newStudentsState = [
          ...this.state.students.filter(el => el.id !== id),
          { ...res.data.data },
        ];

        this.setState({
          studentEmail: {
            updating: false,
            updated: true,
            error: false,
            errorMessages: [],
          },
        });

        this.setState({ students: newStudentsState });
      })
      .catch(e => {
        this.setState({
          studentEmail: {
            updating: false,
            updated: false,
            error: true,
            errorMessages: [...e.response.data.errors],
          },
        });
      });
  };

  updateTeacherEmail = (teacherId, email, classroomId) => {
    this.setState({
      teacherEmail: {
        updating: true,
        updated: false,
        error: false,
        errorMessages: [],
      },
    });

    axios({
      url: `${domain}/api/v1/teachers/${teacherId}`,
      method: 'PATCH',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        data: {
          attributes: {
            email: email,
          },
        },
      }
    })
      .then(res => {
        const targetedClassroom = { ...this.state.classrooms.find(el => el.id === classroomId) };
        const updatedClassroom = {
          ...targetedClassroom,
          attributes: {
            ...targetedClassroom.attributes,
            teacher_email: email,
          },
        };

        const newClassroomState = [
          { ...updatedClassroom },
          ...this.state.classrooms.filter(el => el.id !== classroomId),
        ];

        this.setState({
          teacherEmail: {
            updating: false,
            updated: true,
            error: false,
            errorMessages: [],
          },
        });

        this.setState({ classrooms: newClassroomState });
      })
      .catch(e => {
        this.setState({
          teacherEmail: {
            updating: false,
            updated: false,
            error: true,
            errorMessages: [...e.response.data.errors],
          },
        });
      });
  };

  getClassroomStudents = classroomId => {
    this.setState({
      teacher: {
        ...this.state.teacher,
        fetching: true,
        error: false,
      },
    });

    axios({
      url: `${apiConfig.baseUrl}/classrooms/${classroomId}/relationships/students`,
      method: 'GET',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      }
    })
      .then(res => {
        this.setState({
          teacher: {
            ...this.state.teacher,
            data: [...res.data.included],
            fetching: false,
            error: false,
          },
        });
      })
      .catch(e => {
        this.setState({
          teacher: {
            ...this.state.teacher,
            error: true,
            fetching: false,
          },
        });
      });
  };

  getStudentsPhotos = studentId => {
    this.setState({
      student: {
        ...this.state.student,
        fetching: true,
        error: false,
      },
    });

    axios({
      url: `${apiConfig.baseUrl}/users/${studentId}/relationships/photos`,
      method: 'GET',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      }
    })
      .then(res => {
        this.setState({
          student: {
            ...this.state.student,  
            data: [...res.data.data],
            fetching: false,
            error: false,
          },
        });
      })
      .catch(e => {
        this.setState({
          student: {
            ...this.state.student,
            error: true,
            fetching: false,
          },
        });
      });
  };

  deleteStudentPhoto = (studentId, photoname, photoId) => {
    this.setState({
      photoDelete: {
        ...this.state.photoDelete,
        pending: true,
      },
    });

    axios({
      url: `${apiConfig.baseUrl}/users/${studentId}/relationships/photos`,
      method: 'DELETE',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        file_name: photoname,
      }
    })
      .then(res => {
        const newStudentState = [...this.state.student.data.filter(el => el.id !== photoId)];
        this.setState({
          photoDelete: {
            pending: false,
            error: false,
          },
        });
        this.setState(
          {
            student: {
              ...this.state.student,
              data: newStudentState,
            },
          },
          () => {
            if (newStudentState.length === 0) {
              const showLoading = false;
              this.getStudents(null, showLoading);
            }

            this.getPhotos();
          },
        );
      })
      .catch(e => {
        this.setState({
          photoDelete: {
            pending: false,
            error: true,
          },
        });
      });
  };

  unassignStudentFromClassroom = (classroomId, studentId) => {
    this.setState({
      unassignStudent: {
        pending: true,
        error: false,
      },
    });

    axios({
      url: `${apiConfig.baseUrl}/classrooms/${classroomId}/relationships/students`,
      method: 'DELETE',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        user_ids: [studentId],
      }
    })
      .then(res => {
        this.getStudents();
        this.getClassrooms();
        this.setState({
          teacher: {
            ...this.state.teacher,
            data: [...this.state.teacher.data.filter(el => el.id !== studentId)],
            fetching: false,
            error: false,
          },
        });
      })
      .catch(e => {
        this.setState({
          unassignStudent: {
            pending: false,
            error: true,
          },
        });
      });
  };

  handlePhotoSelect = (photoId, isSelected) => {
    const selectedPhotos = isSelected
      ? [...this.state.selectedPhotos, photoId]
      : [...this.state.selectedPhotos.filter(el => el !== photoId)];

    this.setState({
      selectedPhotos: selectedPhotos,
    });
  };

  clearPhotoSelect = () => {
    this.setState({
      selectedPhotos: [],
    });
  };

  sendPhotosViaEmail = (email) => {
    const { emailPhotos, hidePhotoIds, photos } = this.state;
    const emailPhotosIds = emailPhotos.map(emeilPhoto => emeilPhoto.id);

    axios({
      url: `${apiConfig.baseUrlv2}/send_photos_via_email`,
      method: 'POST',
      auth: {
        username: apiConfig.auth.user,
        password: apiConfig.auth.password,
      },
      data: {
        email,
        photos_ids: emailPhotosIds
      },
    }).then(() => {
      this.setState({
        photos: photos.filter(photo => !emailPhotosIds.includes(photo.id)),
        hidePhotoIds: [...hidePhotoIds, emailPhotosIds],
        emailPhotos: [],
      });
    })
    .catch(() => {
      alert('Sorry, something went wrong. Please try again.');
    });
  }

  clearEmailPhotos = () => {
    this.setState({
      emailPhotos: [],
      hidePhotoIds: [],
    });

    this.globalToggle();
  };

  render() {
    const {
      photos,
      isLoadingStudents,
      isLoadingClassrooms,
      isLoadingPhotos,
      isLoadingAssignment,
      boxOfAssignment,
      hidePhotoIds,
    } = this.state;
    const filteredClassrooms = this.filteredClassrooms();
    const filteredStudents = this.filteredStudents();

    const contentProperties = {
      classroom: {
        ContainerHeader: {
          title: 'Lehrer',
          links: [
            { href: 'https://www.yousty.ch/de-CH/teachers/classrooms/new', icon: 'fas fa-plus fa-lg' },
            { onClick: this.getClassrooms, icon: 'fas fa-sync-alt fa-lg' },
          ],
        },
        SearchForm: {
          id: 'classrooms',
          icon: 'fas fa-search fa-lg',
          changeFilter: this.changeClassroomFilter,
        },
        isLoading: isLoadingClassrooms,
        content: filteredClassrooms,
        droppableId: 'droppableclassrooms',
        undoUpdate: this.undoClassroomUpdate,
        handleClick: this.finishWorkingOnThisClassroom,
        boxOfAssignment: boxOfAssignment,
        isLoadingAssignment: isLoadingAssignment,
      },
      student: {
        ContainerHeader: {
          title: 'Schüler',
          links: [
            { href: 'https://www.yousty.ch/quick_sign_up', icon: 'fas fa-plus fa-lg' },
            { onClick: this.getStudents, icon: 'fas fa-sync-alt fa-lg' },
          ],
        },
        SearchForm: {
          id: 'classrooms',
          icon: 'fas fa-search fa-lg',
          changeFilter: this.changeUsersFilter,
        },
        isLoading: isLoadingStudents,
        content: filteredStudents,
        droppableId: 'droppablestudents',
        undoUpdate: this.undoStudentUpdate,
        handleClick: this.finishWorkingOnThisStudent,
        boxOfAssignment: boxOfAssignment,
        isLoadingAssignment: isLoadingAssignment,
        isStudentBoxMoving: this.state.isStudentBoxMoving,
      },
      photos: {
        ContainerHeader: {
          title: 'Photos',
          links: [
            { onClick: this.clearPhotoSelect, icon: 'fas fa-ban fa-lg', tooltip: 'Auswahl löschen'},
            { href: 'https://858058720855.signin.aws.amazon.com/console', icon: 'fas fa-plus fa-lg', tooltip: 'Bild manuell hinzufügen' },
            !this.state.autoLoadPhotos.active 
              ? { onClick: this.toggleAutoLoadPhotos, icon: 'far fa-stop-circle fa-lg', tooltip: 'Auto. Aktualisierung gestoppt' } 
              : this.state.autoLoadPhotos.paused 
                ? { onClick: this.toggleAutoLoadPhotos, icon: 'fas fa-pause-circle fa-lg', tooltip: 'Auto. Aktualisierung pausiert' } 
                : { onClick: this.toggleAutoLoadPhotos, icon: 'fas fa-play-circle fa-lg', tooltip: 'Auto. Aktualisierung aktiv' },
            { onClick: this.getPhotos, icon: 'fas fa-sync-alt fa-lg', tooltip: 'Aktualisieren' },
          ],
        },
        SearchForm: {
          id: 'classrooms',
          icon: 'fas fa-search fa-lg',
        },
        isLoading: isLoadingPhotos,
        content: photos,
        droppableId: 'droppablephotos',
        hidePhotoIds: hidePhotoIds,
        selectedPhotos: this.state.selectedPhotos,
        draggedPhotos: this.state.draggedPhotos,
        handlePhotoSelect: this.handlePhotoSelect,
        onContainerClick: this.pauseAutoLoadPhoto,
      },
    };

    const content = Object.keys(contentProperties).map(index => {
      return (
        <Container
          type={index}
          key={index}
          properties={contentProperties[index]}
          showStudent={id => this.sidebarShowHandler('student', id)}
          showTeacher={id => this.sidebarShowHandler('teacher', id)}
        />
      );
    });

    let sidebarType;
    if (this.state.student.show) {
      sidebarType = 'student';
    } else if (this.state.teacher.show) {
      sidebarType = 'teacher';
    } else if (this.state.customEmail.show) {
      sidebarType = 'customEmail';
    } else if (this.state.trash.show) {
      sidebarType = 'trash';
    }

    let emailState;
    if (sidebarType === 'teacher') {
      emailState = this.state.teacherEmail;
    } else if (sidebarType === 'student') {
      emailState = this.state.studentEmail;
    } else if (sidebarType === 'customEmail') {
      emailState = this.state.customEmail;
    } else if (sidebarType === 'trash') {
      emailState = this.state.trash;
    }

    return (
      <Fragment>
        <Header onClick={this.handleReload} eventSignupId={apiConfig.eventSignupId} />
        <div
          className={styles.wrapper}
          styles={apiConfig.eventSignupId == null ? 'display: none;' : ''}
        >
          <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
              <Droppable droppableId="droppableemail">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    onClick={() => { this.clickCustomMailIcon() }}
                    className={clsx(
                      snapshot.isDraggingOver ? 'isDraggedOver' : '',
                      styles.droppableEmailArea,
                      "emailArea"
                    )}
                  >
                    {this.state.emailPhotos.length > 0 && (
                      <div className={styles.indicator}>
                        {this.state.emailPhotos.length}
                      </div>
                    )}
                    <i className="fas fa-envelope fa-2x" />
                  </div>
                )}
              </Droppable>
              <Droppable droppableId="droppabletrash">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    onClick={() => { this.clickTrashIcon() }} 
                    className={clsx(
                      styles.trash,
                      snapshot.isDraggingOver ? 'isDraggedOver' : '',
                      "emailArea"
                    )}
                  >
                    {this.state.trashedPhotos.length > 0 && (
                      <div className={styles.indicator}>
                        {this.state.trashedPhotos.length}
                      </div>
                    )}
                    <i className="fas fa-trash fa-2x" />
                  </div>
                )}
              </Droppable>
            {content}
          </DragDropContext>
        </div>
        {(this.state.student.show || this.state.teacher.show || this.state.customEmail.show || this.state.trash.show) && (
          <Sidebar
            sidebar={this.state.sidebar}
            toggle={this.toggleSidebar}
            type={sidebarType}
            sendEmail={this.resendConventionEmail}
            sendPhotosViaEmail={this.sendPhotosViaEmail}
            clearEmailPhotos={this.clearEmailPhotos}
            conventionEmail={this.state.conventionEmail}
            emailState={emailState}
            updateStudentEmail={(id, email) => this.updateStudentEmail(id, email)}
            updateTeacherEmail={(id, email, classroomId) =>
              this.updateTeacherEmail(id, email, classroomId)
            }
            getClassroomStudents={classroomId => this.getClassroomStudents(classroomId)}
            getStudentsPhotos={studentId => this.getStudentsPhotos(studentId)}
            teacher={this.state.teacher}
            student={this.state.student}
            customEmail={this.state.customEmail}
            trash={this.state.trash}
            trashedPhotos={this.state.trashedPhotos}
            emailPhotos={this.state.emailPhotos}
            deletePhotoFromEmailPhotos={this.deletePhotoFromEmailPhotos}
            handleDelete={this.deleteStudentPhoto}
            restorePhotoFromTrash={this.restorePhotoFromTrash}
            restoreAllPhotosFromTrash={this.restoreAllPhotosFromTrash}
            emptyTrash={this.emptyTrashConfirmation}
            isLoadingTrashSidebar={this.state.isLoadingTrashSidebar}
            unassignStudent={(classroomId, studentId) =>
              this.unassignStudentFromClassroom(classroomId, studentId)
            }
          />
        )}
        {(this.state.student.show || this.state.teacher.show) && (
          <Backdrop toggle={this.globalToggle} />
        )}
      </Fragment>
    );
  }
}

export default PhotosDragAndDropApp;



// WEBPACK FOOTER //
// ./src/containers/PhotosDragAndDropApp/PhotosDragAndDrop.js